import { Hidden } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  commodityList,
  getAllContractList,
  getCommodityVariertyList,
  getContractStage,
  getContractType,
  getDestinationByType,
  getSelectedContractDetail,
  InternalDestinationList
} from "../../../modules/contract/action";
import {
  getAllTicketList,
  getCounterpartList,
  getLoadNumberIndicatorList,
  getOriginType
} from "../../../modules/ticket/action";
import { trucklineListAction } from "../../../modules/truckline/action";
import "../../../style";
import Button from "../../FormElement/Button";
import DataRangePicker from "../../FormElement/DatePickerRange";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import MultipleSelect from "../../FormElement/MultipleSelect";

const defaultDestinationTypeId = "2";

class ReportsFormList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportsFilter: {
        startdate: "",
        enddate: "",
        contract: "",
        origin: "",
        loadnumberindicator: "",
        commodity: "",
        commodityVariety: [],
        commodityVarietyListOption: [],
        counterpart: "",
        destination: "",
        truckline: "",
        farmId: this.props.SubFarmId
          ? this.props.SubFarmId
          : userFarmDetail().id || this.props.MainFarmId,
        harvestYear: harvestYearDetail().name,
        counterPartyEnum:'ONBOARDED'
      },
      ONBOARDED:'ONBOARDED',
      commodityVarietyListOption: [],
      formErrors: {},
      isValid: true,
      successMessage: "",
      errorMessage: {},
      getOriginListOptions: [],
      showDateRange: false,
      dateRangeValue: "",
      comodityVariety: {
        selectedOptions: []
      }
    };
  }

  componentDidMount() {
    const { selectedYear } = this.props;
  }

  componentWillMount() {
    const destinationType = "External";

    let id = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id
      ? userFarmDetail().id
      : this.props.MainFarmId;
    const harvestYearId = harvestYearDetail().name;
    this.props.actions.getCommodityVariertyList(harvestYearId);
    this.props.actions.getAllContractList(id, harvestYearId);
    this.props.actions.getCounterpartList(id, harvestYearId);
    this.props.actions.getContractStage();
    this.props.actions.getContractType();
    this.props.actions.getLoadNumberIndicatorList(harvestYearId);
    this.props.actions.getDestinationByType(destinationType, harvestYearId);
    this.props.actions.InternalDestinationList("Internal").then(() => {
      this.props.actions.getOriginType().then(() => {
        this.getOriginList();
      });
    });
    this.props.actions.trucklineListAction();
  }
  multiSelectHandleChange = selectedVarietyArr => {
    const selectedOptionIds = selectedVarietyArr
      ? selectedVarietyArr.map(selectedVariety => selectedVariety.value)
      : [];
    this.setState(prevState => {
      return {
        reportsFilter: {
          ...prevState.reportsFilter,
          commodityVariety: selectedOptionIds
        }
      };
    });
  };
  handleChange = event => {
    const { name, value, label } = event.target;
    if (name === "commodity") {
      this.getVariertyList(value);
      if (value === "") {
        this.setState(
          prevState => {
            return {
              reportsFilter: {
                ...prevState.reportsFilter,
                commodityVariety: ""
              }
            };
          },
          () => {
            this.setState({
              comodityVariety: { selectedOptions: [] }
            });
          }
        );
      }
    }
    if (name === "originId") {
      this.setState(prevState => {
        return {
          reportsFilter: {
            ...prevState.reportsFilter,
            [name]: value,
            origin: value ? value.toString().split("_")[0] : "",
            originTypeId: value ? value.toString().split("_")[1]||"2" : "2"
          }
        };
      });
    } else {
       console.log(name)
       if(name==="counterpart"&& label){
        this.setState({ONBOARDED:label.includes('✅')?'ONBOARDED':'VIRTUAL'
      })
}

      this.setState(
        prevState => {
          return {
            reportsFilter: {
              ...prevState.reportsFilter,
              [name]: value
            }
          };
        },
        () => {
          const { reportsFilter, formErrors } = this.state;
          this.setState({
            isValid: validForm(formErrors, reportsFilter)
          });
        }
      );
    }
  };
  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        this.setState({
          isValid: validForm(this.state.formErrors)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      const destinationType = "External";

      let id = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id;
      const harvestYearId = harvestYearDetail().name;
      this.props.actions.getCommodityVariertyList(harvestYearId);
      this.props.actions.getAllContractList(id, harvestYearId);
      this.props.actions.getCounterpartList(id, harvestYearId);
      this.props.actions.getContractStage();
      this.props.actions.getContractType();
      this.props.actions.getLoadNumberIndicatorList(harvestYearId);
      this.props.actions.getDestinationByType(destinationType, harvestYearId);
      this.props.actions.InternalDestinationList("Internal").then(() => {
        this.props.actions.getOriginType().then(() => {
          this.getOriginList();
        });
      });
      this.props.actions.trucklineListAction();
    }

    if (
      nextProps.MainFarmId !== this.props.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.setState({
        reportsFilter: {
          startdate: "",
          enddate: "",
          contract: "",
          origin: "",
          loadnumberindicator: "",
          commodity: "",
          commodityVarietyListOption: [],
          counterpart: "",
          destination: "",
          truckline: "",
          farmId: this.props.SubFarmId
            ? this.props.SubFarmId
            : userFarmDetail().id || this.props.MainFarmId,
          harvestYear: harvestYearDetail().name
        },
        formErrors: {}
      });
      const destinationType = "External";

      let id = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id
        ? userFarmDetail().id
        : this.props.MainFarmId;
      const harvestYearId = harvestYearDetail().name;
      this.props.actions.getCommodityVariertyList(harvestYearId);
      this.props.actions.getAllContractList(id, harvestYearId);
      this.props.actions.getCounterpartList(id, harvestYearId);
      this.props.actions.getContractStage();
      this.props.actions.getContractType();
      this.props.actions.getLoadNumberIndicatorList(harvestYearId);
      this.props.actions.getDestinationByType(destinationType, harvestYearId);
      this.props.actions.InternalDestinationList("Internal").then(() => {
        this.props.actions.getOriginType().then(() => {
          this.getOriginList();
        });
      });
      this.props.actions.trucklineListAction();
    }
  }

  generateReport = e => {
    e.preventDefault();
    const { reportsFilter } = this.state;
    console.log(reportsFilter);
    reportsFilter.farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id || this.props.MainFarmId;
    reportsFilter.harvestYear = harvestYearDetail().name;
    reportsFilter['counterPartyEnum'] = this.state.ONBOARDED
    // reportsFilter.commodityVariety = [
    //   reportsFilter.commodityVarietyListOption
    // ];
    var finalFilter = JSON.parse(JSON.stringify(reportsFilter));
    var queryString = Object.keys(finalFilter)
      .map(key => {
        return key + "=" + reportsFilter[key] || "";
      })
      .join("&");
    this.props.reportGenerated(queryString);
  };

  getfilterCommodityList = () => {
    const { commodityVarietyList } = this.props;
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };
  getContractOptionsList = () => {
    const { ContractList } = this.props;
    let comm = ContractList !== undefined ? ContractList : {};
    let commarray = [];
    commarray = Object.keys(comm)
      .filter(value => !comm[value].disable)
      .map(value => {
        return {
          id: comm[value].id,
          name: comm[value].name
        };
      });
    return commarray;
  };
  getDestinationOptionsList = () => {
    const {
      ExternalDestinationOptions = [],
      InternalDestinationOptions = []
    } = this.props;
    const destinationList = [
      ...ExternalDestinationOptions,
      ...InternalDestinationOptions
    ];
    return destinationList;
  };

  getOriginList = () => {
    const {
      OriginTypeFieldBased = [],
      InternalDestinationOptions = []
    } = this.props;
    var onSite = [...InternalDestinationOptions];
    // onSite.length > 0 &&
    onSite = onSite.map(value => {
      const el = { ...value };
      el.name = el.name + " (On-site)";
      return el;
    });
    let FieldBased =
      OriginTypeFieldBased.length > 0 &&
      OriginTypeFieldBased.map(value => {
        value.id = value.id + "_1";
        value["name"] = value.name + " (Field)";
        return value;
      });

    const originList = [...FieldBased, ...onSite];
    this.setState({ getOriginListOptions: originList });
  };

  onRangeSelect = range => {
    const { start, end } = range;
    if (range) {
      this.setState(prevState => {
        return {
          reportsFilter: {
            ...prevState.reportsFilter,
            startdate: new Date(moment(start._d).format()).toISOString(),
            enddate: new Date(
              moment(end._d)
                .add({ hours: 23, minutes: 59 })
                .format()
            ).toISOString()
          }
        };
      });
    }
  };

  getVariertyList = (id, VarietyId) => {
    const { commodityVarietyList } = this.props;
    let option = commodityVarietyList.filter(
      value => value.commodityResponseDTO.id === id
    );
    this.setState(prevState => {
      return {
        ...prevState,
        commodityVarietyListOption: option
      };
    });
  };

  render() {
    const {
      successMessage,
      isValid,
      reportsFilter,
      getOriginListOptions,
      dateRangeValue,
      commodityVarietyListOption,
      comodityVariety
    } = this.state;
    const {
      LoadNumberIndicatorList,
      BrokerList,
      trucksListOptions,
      getfilterCommodityVarietyList
    } = this.props;
    // if (successMessage) {
    //   return <Redirect to="/farmsetup/trucklines" />;
    // }
    return (
      <div className="reportFormList">
        <Grid container spacing={24} height={200}>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <DataRangePicker onSelect={range => this.onRangeSelect(range)} />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.contract}
              label="Contract"
              type="text"
              name="contract"
              //validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              options={this.getContractOptionsList()}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.originId}
              label="Origin"
              type="text"
              name="originId"
              //validations={['required']}
              handleChange={this.handleChange}
              options={getOriginListOptions}
              //   handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.loadnumberindicator}
              label="Load No Indicator"
              type="text"
              name="loadnumberindicator"
              options={LoadNumberIndicatorList}
              //validations={['required']}
              handleChange={this.handleChange}
              //handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.commodity}
              label="Commodity"
              type="text"
              name="commodity"
              //validations={['required']}
              options={this.getfilterCommodityList()}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          {/* <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.commodityVarietyListOption}
              label="Commodity Variety"
              type="text"
              name="commodityVarietyListOption"
              //validations={['required']}
              options={commodityVarietyListOption}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid> */}

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              label="Commodity Variety"
              isMulti
              value={reportsFilter.commodityVariety}
              options={commodityVarietyListOption}
              handleChange={this.multiSelectHandleChange}
              selectedOptions={comodityVariety.selectedOptions}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.counterpart}
              label="Counterpart"
              type="text"
              name="counterpart"
              options={BrokerList}
              //validations={['required']}
              handleChange={this.handleChange}
              //handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.destination}
              label="Destination"
              type="text"
              name="destination"
              options={this.getDestinationOptionsList()}
              // validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.truckline}
              label="Truckline"
              type="text"
              name="truckline"
              options={trucksListOptions}
              // validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          <Grid item md={3} implementation="css" smDown component={Hidden} />
          <Grid item md={3} implementation="css" smDown component={Hidden} />

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="flex-display ticket-header">
              <Link to="#" style={{ marginLeft: "auto" }}>
                <Button name="Generate Report" onclick={this.generateReport} />
              </Link>
            </div>
          </Grid>
        </Grid>

        {/* {this.state.showDateRange ? (
          <DatePickerRange handleDateRange={this.handleDateRange} />
        ) : null} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ContractList: state.contractReducer.ContractList,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    ContractStageList: state.contractReducer.ContractStageList,
    ContractTypeList: state.contractReducer.ContractTypeList,
    BrokerList: state.ticketReducer.CounterPart,
    OriginTypeFieldBased: state.ticketReducer.originTypeInternal,
    LoadNumberIndicatorList: state.ticketReducer.LoadNumberIndicatorList,
    ExternalDestinationOptions: state.contractReducer.DestinationList,
    InternalDestinationOptions: state.contractReducer.InternalDestinationList,
    selectedContractDetails: state.contractReducer.selectedContractDetails,
    trucksListOptions: state.trucklineReducer.trucksList,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getAllContractList,
        getOriginType,
        getDestinationByType,
        getLoadNumberIndicatorList,
        InternalDestinationList,
        trucklineListAction,
        getSelectedContractDetail,
        getAllTicketList
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsFormList);



// WEBPACK FOOTER //
// ./src/components/private/Reports/ReportsFormList.js